import axiosInstance from "../../../axios/axios";
import { formatDateTimeToString } from "../../../helper/formatDateTimeToString";

export const getHorseOwners = () =>
    new Promise((resolve, reject) => {
        axiosInstance.get(
            "/semenmarket/getowners",
        ).then(res => {
            const buyersList = res?.data?.result ?? [];
            resolve(buyersList);
        }).catch(error => {
            reject(error);
        });
    });

export const filterHorses = (filters) =>
    new Promise((resolve, reject) => {
        axiosInstance.get(
            "/semenmarket/getfiltered",
            {
                params: filters
            }
        ).then(res => {
            const horsesList = res?.data ?? [];
            resolve(horsesList);
        }).catch(error => {
            reject(error);
        });
    });

export const getHorseById = (id) =>
    new Promise((resolve, reject) => {
        axiosInstance
            .get(`/semenmarket/getbyid/${id}`)
            .then(res => {
                const data = res?.data?.result;
                if (!data) {
                    resolve(null);
                    return;
                }
                const mappedHorse = {
                    images:
                        data?.stallionImage?.length > 0
                            ? data?.stallionImage.map(x => (x?.fileUrl))
                            : [],
                    stallionImage: data?.stallionImage || [],
                    videos: data?.videoUrl ?? [],
                    stallionId: data?.stallionId || '',
                    horseName: data?.stallionName || '',
                    birthDate: data?.stallionBirthDate
                        ? formatDateTimeToString(data?.stallionBirthDate)
                        : '',
                    isBestHorses: data?.isBestHorses ?? false,
                    color: data?.colorName || '',
                    owner: data?.ownerName || '',
                    address: data?.address || '',
                    origin: data?.originName || '',
                    ownerMail: data?.contactEmail?.trim() || '',
                    ownerPhone: data?.contactPhone || '',
                    price: data?.price || 0,
                    regNr: data?.regNr ?? '',
                    sire: data?.sireName || '',
                    dam: data?.damName || '',
                    description: data?.description || '',
                    isOutOfStock: data?.isOutOfStock ?? false,
                    sireName: data?.sireName || '',
                    damName: data?.damName || '',
                };

                resolve(mappedHorse);
            })
            .catch(error => {
                reject(error);
            });
    });
